import { MutableRefObject, Ref, RefCallback } from 'react';

function setRef<T>(ref: Ref<T>, value: T) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    (ref as MutableRefObject<T>).current = value;
  }
}

export function combineRefs<T>(
  ...refs: Array<Ref<T> | undefined>
): RefCallback<T> | null {
  return (refValue: T) => {
    refs.forEach((r) => r && setRef(r, refValue));
  };
}
